/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/location'
export default icon
